import React, { useContext, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { IconButton } from '@fluentui/react/lib/Button';
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { useGetTypeOfsMaintainer } from "../../../../hooks/services/sKPI/useOfTypeOf";
import { addTypeOf, addTypeOfList, deleteTypeOf, getTypeOfById, saveTypeOfById } from "../../../../services/sKPI/typeOf.service";
import { downloadCSV, getGridLocalization, isNullOrEmpty, isNullUndefinedOrEmpty, showMessage } from "../../../../common/Helpers";
import MessageBox from "../../../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../../../common/Dictionaries";
import MainAppContext from "../../../../MainAppContext";
import * as XLSX from 'xlsx';

import ProfileVerify from "../../../../components/Templates/Site/ProfileVerify";
import TemplateDoc from '../../../../templates/sKPI/Mantainers/tmp_TypeOfs.csv'
import MatrixToolbar from '../../../../components/Products/sPrivilege/Matrix/MatrixToolbar';
import { applyFilters, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, setterActionFired, useFilterActionComponentData } from '../../../../common/Helpers/JqxGridFilter';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
export default function TypeOf(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)
    
    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [editingRows, setEditingRows] = useState([]);
    const [listTypeOfs, setListTypeOfs] = useState(null);
    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);

    useGetTypeOfsMaintainer(listTypeOfs, setListTypeOfs, null, null);

    useFilterActionComponentData(gridRef, messageConfig, "TypeOf");

    const validateObject = (object) => {
        const isValid = object.name !== undefined && object.name !== null && object.name !== '';

        return isValid;
    };

    const handlerAddNewRow = (obj) => {
        const _lowerId = listTypeOfs.length !== 0 ? listTypeOfs.reduce((min, obj) => obj.id < min ? obj.id : min, listTypeOfs[0].id) : 0;
        const lowerId = listTypeOfs.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id: lowerId,
            name: "",
            typeOfCode: "",
            typeOfNemo: "",
            description: ""
        } : {
            id: lowerId,
            name: obj.name,
            typeOfCode: obj.typeOfCode,
            typeOfNemo: obj.typeOfNemo,
            description: obj.description
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listTypeOfs.unshift(newRow);
        setListTypeOfs(listTypeOfs);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId)
            setEditingRows(editingRows);
        }
        
        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("TypeOf", 1)
    };

    const handleUploadData = () => {
        fileInputRef.current.click();
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const convertedData = jsonData.slice(1).map((row, rowIndex) => {
                const convertedRow = {};
                row.forEach((cell, columnIndex) => {
                    const columnName = columns.find(x => x.index === columnIndex).dataField;
                    convertedRow[columnName] = cell;
                });

                convertedRow.id = null;

                return convertedRow;
            });

            convertedData.forEach(element => {
                handlerAddNewRow(element)
            });
        };

        reader.readAsArrayBuffer(file);
        fileInputRef.current.value = '';
    };

    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    }

    const handleExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            const aux_list = listTypeOfs.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                columns.forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: columns.filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'TypeOf_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'TypeOf_UploadTemplate.xlsx');
        }
    };

    const isValidFormControls = (list) => {
        let isValidForm = true;

        list.forEach(element => {
            if (element.name === '' || element.name === null || element.name === undefined) {
                isValidForm = false;
            }

            let aux_coincidences = list.filter(x => x.id !== element.id && x.name === element.name);

            if (aux_coincidences !== null && aux_coincidences !== undefined) {
                if (aux_coincidences.length > 0) {
                    isValidForm = false;
                }
            }

            //document.getElementById("invalidTextbox" + element.id).setAttribute("style", "display: none");           
        });
    
        return isValidForm;
    };

    const handlerSaveAll = () => {
        //Obtener todos los elementos con id <= 0, ya que estos son los elementos a agregar.
        const aux_list = listTypeOfs.filter(x => x.id <= 0);
        
        //Validar cada elemento, que el name no este blanco.
        const frmIsValid = isValidFormControls(aux_list);

        if (frmIsValid === true) {
            addTypeOfList(aux_list).then((response) => {
                if (response.data.succeeded) {
                    setListTypeOfs(null);
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("TypeOf", 1)
            }).catch((err) => {
                //De haber falla se devolvera arreglo con ID (en negativo) y la razon de la falla.
                //Se deben gatillar los errores de los que no pudieron ser guardados.
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("TypeOf", 1)
            });
        } else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerSave = async (itemId) => {    
        const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);

        if (validateObject(item)) {
            if (itemId <= 0) {
                item.typeOfNemo = "";
                item.typeOfCode = "";

                await addTypeOf(item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))

                        listTypeOfs.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data.id;
                                element.typeOfCode = serviceResponse.data.data.typeOfCode;
                            }
                        });

                        setListTypeOfs(listTypeOfs);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }        
                    setterActionFired("TypeOf", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("TypeOf", 1)
                });
            }
            else {
                saveTypeOfById(itemId, item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id))
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }  
                    setterActionFired("TypeOf", 1)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setterActionFired("TypeOf", 1)
                });
            }

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {
        if (itemId <= 0) {
            const newListTypeOf = listTypeOfs.filter(x => x.id !== itemId);
            setListTypeOfs(newListTypeOf)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("TypeOf", 1)
        }
        else {
            await deleteTypeOf(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    const newListTypeOf = listTypeOfs.filter(x => x.id !== itemId);
                    setListTypeOfs(newListTypeOf)
                    setEditingRows(editingRows.filter(x => x !== itemId));

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))  
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("TypeOf", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("TypeOf", 1)
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListTypeOf = listTypeOfs.filter(x => x.id !== itemId);
            setListTypeOfs(newListTypeOf)
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
            setterActionFired("TypeOf", 1)
        }
        else {
            await getTypeOfById(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listTypeOfs.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property]
                            }
                        }
                    });
            
                    setListTypeOfs(listTypeOfs);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
                setterActionFired("TypeOf", 1)
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                setterActionFired("TypeOf", 1)
            });
        }
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const isEditing = editingRows.find(x => x === itemId);
        return  <>
                {
                    profileHasAccess &&
                    <>
                            {isEditing ? (
                                <>
                                    {
                                        itemId <= 0 ? (
                                            <>
                                                <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                            </>
                                        ) : (
                                            <>
                                                <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                                <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                            </>
                                        )
                                    }
                                </>
                            ) : (
                                <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                            )}
                        </>
                }
                </>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId)
                break;
            case 'delete':
                handlerDelete(itemId)
                break;
            case 'cancel':
                handlerCancel(itemId, listTypeOfs)
                break;
            default:
                break;
        }
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listTypeOfs[rowIndex.boundindex].id;
        }
        return listTypeOfs[rowIndex]?.id;
    };

    const onCellvaluechanged = (e) => {
        const currentColumn = e.owner._columns.find(x => x.datafield === e.args.datafield);

        if (currentColumn.columntype === "dropdownlist") {
            listTypeOfs[e.args.rowindex][e.args.datafield] = e.args.value.value
        }
        else {
            listTypeOfs[e.args.rowindex][e.args.datafield] = e.args.value
        }

        const copia_listTypeOfs = JSON.parse(JSON.stringify(listTypeOfs));
        setListTypeOfs(copia_listTypeOfs);

        if (editingRows.find(x => x === listTypeOfs[e.args.rowindex].id) === undefined) {
            editingRows.push(listTypeOfs[e.args.rowindex].id)
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'TypeOf', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "textbox":
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };

    const columns = [
        { index: null, text: 'ID',                           dataField: 'id',            uploadMasive: false, exportable: false, width: '0%',  columntype: 'textbox', editable: false, hidden: true },
        { index: null, text: t('data-lang-lbl-actions'),     dataField: 'acciones',      uploadMasive: false, exportable: false, width: '5%', pinned: true,
            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
        },
        { index: null, text: t('data-lang-lbl-code'),        dataField: 'typeOfCode',    uploadMasive: false, exportable: true,  width: '10%', columntype: 'textbox', editable: false, pinned: true },
        { index: 0,    text: t('data-lang-lbl-name'),        dataField: 'name',          uploadMasive: true,  exportable: true,  width: '30%', columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox') },
        { index: 1,    text: t('data-lang-lbl-description'), dataField: 'description',   uploadMasive: true,  exportable: true,  width: '55%', columntype: 'textbox' },
    ]

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-typeof')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox  
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="d-none">
                        <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handleFileUpload} />
                        <a id="btnGetTemplate" href={TemplateDoc} download="TypeOfTemplate.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                    </div>
                    {
                        listTypeOfs !== null &&
                        <div className="align-items-center h-100">
                            <MatrixToolbar
                                inputParam_HandleSaveData={handlerSaveAll}
                                inputParam_HandleUploadData={handleUploadData}
                                inputParam_HandleExportData={handleExportData}
                                inputParam_HandleAddRow={handlerAddNewRow}
                                inputParam_Configuration={{
                                    buttons: {
                                        showRowButtons: profileHasAccess,
                                        showExportData: true,
                                        showAddMasiveData: profileHasAccess,
                                        showAddData: profileHasAccess,
                                        showDownloadTemplate: profileHasAccess,
                                        showSaveAllData: profileHasAccess,
                                        groupedButtons: profileHasAccess
                                    },
                                    handlers: {
                                        handlerSave: profileHasAccess ? handlerSave : null,
                                        handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                        handlerDelete: profileHasAccess ? handlerDelete : null,
                                        handlerCancel: profileHasAccess ? handlerCancel : null,
                                    },
                                    auxiliarListCallbackOnAdd: null,
                                }}
                                inputParam_ExternalExportTemplates={[
                                    {
                                        id: 'btnMantGetTemplate',
                                        key: 'btnMantGetTemplate',
                                        text: t('data-lang-lbl-uploadtemplate'),
                                        iconProps: { iconName: 'ExcelDocument' },
                                        onClick: () => handleExportData(false)
                                    }
                                ]}
                                inputParam_CustomOpenPanel={false}
                                showRequiredMessage={showRequiredGlobalMessage}
                            />
                            <JqxGrid
                                ref={gridRef}
                                altrows={true}
                                enabletooltips={true}
                                width={'100%'}
                                theme={'light'} 
                                autoheight={true}
                                editable={true}
                                pageable={true}
                                sortable={true}
                                filterable={true}
                                showfilterrow={true} 
                                localization={getGridLocalization(t)}
                                source={ new jqx.dataAdapter({
                                    localData: listTypeOfs,
                                    dataType: 'array',
                                    dataFields: [
                                        { name: 'id',           type: 'number' },
                                        { name: 'typeOfCode',   type: 'string' },
                                        { name: 'name',         type: 'string' },
                                        { name: 'description',  type: 'string' },
                                    ],
                                    id: 'id'
                                })}
                                columns={columns}
                                onCellvaluechanged={onCellvaluechanged} 
                                onFilter={(event) => handlerFilter(event, 'TypeOf')}
                            />
                        </div>
                    }
                </Card.Body>
            </Card>           
        </div>
    ); 
}